import React from 'react';
import PropTypes from 'prop-types';

const Delete = ({ fill = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2081 4.02936H13.0581V4.50891H14.0873V3.96223C14.0874 3.43168 13.656 3 13.1257 3H10.1404C9.61013 3 9.17871 3.43168 9.17871 3.96223V4.50891H10.2081V4.02936Z"
      fill={fill || 'var(--PRIMARY)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.80198 8.59375H16.4643C16.7291 8.59375 16.9375 8.81961 16.916 9.08358L16.1083 19.0721C16.0632 19.6298 15.5981 20.0593 15.0393 20.0593H8.22685C7.66806 20.0593 7.20295 19.6298 7.15794 19.0722L6.35014 9.08358C6.3288 8.81961 6.53722 8.59375 6.80198 8.59375ZM9.10932 18.995C9.11999 18.995 9.13079 18.9946 9.14159 18.9939C9.42521 18.9764 9.64105 18.7323 9.62348 18.4485L9.11739 10.2484C9.09996 9.9645 8.85472 9.74918 8.57201 9.76635C8.28839 9.78379 8.07255 10.028 8.08998 10.3117L8.5962 18.5119C8.61299 18.7848 8.83949 18.995 9.10932 18.995ZM12.1536 18.4803C12.1536 18.7644 11.9232 18.9948 11.6389 18.9948C11.3546 18.9948 11.1242 18.7644 11.1242 18.4803V10.28C11.1242 9.99572 11.3546 9.76531 11.6389 9.76531C11.923 9.76531 12.1536 9.99572 12.1536 10.28V18.4803ZM14.693 18.5105L15.1763 10.3103C15.193 10.0266 14.9765 9.78288 14.6927 9.76622C14.4082 9.74944 14.1654 9.96593 14.1488 10.2497L13.6656 18.45C13.6488 18.7337 13.8653 18.9773 14.1491 18.994C14.1593 18.9946 14.1696 18.9948 14.1798 18.9948C14.4501 18.9948 14.677 18.7839 14.693 18.5105Z"
      fill={fill || 'var(--PRIMARY)'}
    />
    <path
      d="M18.244 7.00349L17.906 5.99026C17.8169 5.72316 17.5669 5.54297 17.2852 5.54297H5.98082C5.69928 5.54297 5.44909 5.72316 5.3601 5.99026L5.0221 7.00349C4.95692 7.1989 5.04174 7.39821 5.20008 7.49761C5.26461 7.53807 5.34098 7.5624 5.42489 7.5624H17.8412C17.9252 7.5624 18.0017 7.53807 18.0661 7.49748C18.2244 7.39808 18.3092 7.19877 18.244 7.00349Z"
      fill={fill || 'var(--PRIMARY)'}
    />
  </svg>
);

Delete.propTypes = {
  fill: PropTypes.string,
};

export default Delete;
